import { fork } from 'typed-redux-saga';

import { Logger } from '../../../../../shared/helpers/loggerFacade';
import { RecorderVideo } from '../recorder/RecorderVideo';
import { RecordHelpers, startRecordSaga } from '../recorder/sagas';

export function* recordSaga({
    recorderVideo,
    helpers,
    logger,
}: {
    recorderVideo: RecorderVideo;
    helpers: RecordHelpers;
    logger: Logger;
}) {
    logger.debug('forking record saga');

    yield* fork(startRecordSaga, {
        video: recorderVideo,
        fps: 30,
        helpers,
    });
}
